// test2557
(2557 && 0);
